// src/pages/AdminMessages.jsx
import {useEffect, useState} from "react";
import {supabase} from "../../services/supabase";
import {jsPDF} from "jspdf";


export default function AdminMessages() {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(5);
    const [search, setSearch] = useState("");
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [ selectedIds,setselectedIds]  = useState([]);

    useEffect(() => {
        const fetchMessages = async () => {
            const { data, error } = await supabase
                .from("messages")
                .select("*")
                .order("created_at", { ascending: false });
            if (error) console.error("Error fetching messages:", error);
            else setMessages(data);
            setLoading(false);
        };
        fetchMessages();
    }, []);
// eslint-disable-next-line
    const handleExportPDF = () => {
        const doc = new jsPDF();
        const margin = 10;
        const lineHeight = 7;
        const pageHeight = doc.internal.pageSize.height;

        selectedIds.forEach((id, index) => {
            const msg = messages.find(m => m.id === id);
            if (!msg) return;

            const content = [
                `Name: ${msg.first_name} ${msg.last_name}`,
                `Email: ${msg.email}`,
                `Phone: ${msg.phone}`,
                `Service: ${msg.service}`,
                `Date: ${new Date(msg.created_at).toLocaleString()}`,
                `Message: ${msg.message}`,
            ];

            let y = margin;

            if (index > 0) doc.addPage();

            content.forEach(line => {
                const splitText = doc.splitTextToSize(line, 180); // wrap long text
                splitText.forEach(textLine => {
                    if (y + lineHeight > pageHeight - margin) {
                        doc.addPage();
                        y = margin;
                    }
                    doc.text(textLine, margin, y);
                    y += lineHeight;
                });
            });
        });

        doc.save("selected_messages.pdf");
    };

    const filteredMessages = messages.filter(
        (msg) =>
            msg.email.toLowerCase().includes(search.toLowerCase()) ||
            `${msg.first_name} ${msg.last_name}`.toLowerCase().includes(search.toLowerCase())
    );

    const start = (page - 1) * pageSize;
    const paginatedMessages = filteredMessages.slice(start, start + pageSize);
    const totalPages = Math.ceil(filteredMessages.length / pageSize);

    return (
        <section className="py-4 overflow-hidden">
            <div className="container px-4 mx-auto">
                <div className="pt-5 bg-neutral-50 border border-neutral-100 rounded-xl">
                    <div className="px-6">
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-4">
                            <h3 className="font-heading text-lg text-neutral-600 font-semibold">Client Messages</h3>
                            <div className="flex flex-col sm:flex-row sm:items-center gap-3 w-full sm:w-auto">
                                <input
                                    type="text"
                                    placeholder="Search by name or email"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-orange-500 focus:border-orange-500 w-full sm:w-64"
                                />
                                <button
                                    onClick={async () => {
                                        // eslint-disable-next-line no-restricted-globals
                                        if (!confirm(`Delete ${selectedIds.length} message(s)?`)) return;
                                        const {error} = await supabase
                                            .from("messages")
                                            .delete()
                                            .in("id", selectedIds);
                                        if (error) console.error(error);
                                        else {
                                            setMessages(prev => prev.filter(m => !selectedIds.includes(m.id)));
                                            setselectedIds([]);
                                        }
                                    }}
                                    disabled={selectedIds.length === 0}
                                    className="px-4 py-2 bg-red-600 text-white rounded-md disabled:opacity-50"
                                >
                                    Delete Selected
                                </button>
                                <button
                                    onClick={handleExportPDF}
                                    disabled={selectedIds.length === 0}
                                    className="px-4 py-2 bg-blue-600 text-white rounded-md disabled:opacity-50"
                                >
                                    Export PDF
                                </button>

                            </div>
                        </div>
                        <div className="w-full overflow-x-auto">
                            <table className="w-full min-w-max">
                            <thead>
                                <tr className="text-left text-sm text-gray-400">
                                    <th className="py-3 pr-4">
                                        <input
                                            type="checkbox"
                                            checked={paginatedMessages.every(msg => selectedIds.includes(msg.id))}
                                            onChange={() => {
                                                const pageIds = paginatedMessages.map(m => m.id);
                                                setselectedIds(prev =>
                                                    pageIds.every(id => prev.includes(id))
                                                        ? prev.filter(id => !pageIds.includes(id))
                                                        : Array.from(new Set([...prev, ...pageIds]))
                                                );
                                            }}
                                        />
                                    </th>
                                    <th className="py-3 pr-4">ID</th>
                                    <th className="py-3 pr-4">Email</th>
                                    <th className="py-3 pr-4">Name</th>
                                    <th className="py-3 pr-4">Date</th>
                                    <th className="py-3 pr-4">Phone</th>
                                    <th className="py-3 pr-4">Service</th>
                                    <th className="py-3 pr-4">Message</th>
                                </tr>
                                </thead>
                                <tbody>
                                {loading ? (
                                    <tr>
                                        <td className="py-3 px-4" colSpan="7">Loading...</td>
                                    </tr>
                                ) : paginatedMessages.length === 0 ? (
                                    <tr>
                                        <td className="py-3 px-4" colSpan="7">No messages found.</td>
                                    </tr>
                                ) : (
                                    paginatedMessages.map((msg) => (
                                        <tr
                                            key={msg.id}
                                            className="border-b border-neutral-100 cursor-pointer hover:bg-orange-50"
                                            onClick={() => setSelectedMessage(msg)}
                                        >
                                            <td className="py-3 pr-4">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedIds.includes(msg.id)}
                                                    onChange={() => {
                                                        setselectedIds(prev =>
                                                            prev.includes(msg.id)
                                                                ? prev.filter(id => id !== msg.id)
                                                                : [...prev, msg.id]
                                                        );
                                                    }}
                                                />
                                            </td>
                                            <td className="py-3 pr-4 text-sm">{msg.id}</td>
                                            <td className="py-3 pr-4 text-sm">{msg.email}</td>
                                            <td className="py-3 pr-4 text-sm font-semibold">{msg.first_name} {msg.last_name}</td>
                                            <td className="py-3 pr-4 text-sm">{new Date(msg.created_at).toLocaleString()}</td>
                                            <td className="py-3 pr-4 text-sm">{msg.phone}</td>
                                            <td className="py-3 pr-4 text-sm capitalize">{msg.service}</td>
                                            <td className="py-3 pr-4 text-sm truncate max-w-xs">{msg.message}</td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>
                        <div className="flex justify-between items-center pt-6">
                            <button
                                onClick={() => setPage((p) => Math.max(p - 1, 1))}
                                className="text-sm text-orange-600 font-semibold hover:underline disabled:opacity-50"
                                disabled={page === 1}
                            >
                                Previous
                            </button>
                            <span className="text-sm text-gray-600">
                Page {page} of {totalPages}
              </span>
                            <button
                                onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                                className="text-sm text-orange-600 font-semibold hover:underline disabled:opacity-50"
                                disabled={page === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>

                {selectedMessage && (
                    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                        <div className="bg-white w-full max-w-lg rounded-lg shadow-lg p-6">
                            <div className="flex justify-between items-center mb-4">
                                <h4 className="text-lg font-semibold">Message Details</h4>
                                <button
                                    onClick={() => setSelectedMessage(null)}
                                    className="text-gray-500 hover:text-red-600 text-xl font-bold"
                                >
                                    &times;
                                </button>
                            </div>
                            <div className="space-y-2 text-sm text-gray-700">
                                <p><strong>Name:</strong> {selectedMessage.first_name} {selectedMessage.last_name}</p>
                                <p><strong>Email:</strong> {selectedMessage.email}</p>
                                <p><strong>Phone:</strong> {selectedMessage.phone}</p>
                                <p><strong>Service:</strong> {selectedMessage.service}</p>
                                <p><strong>Date:</strong> {new Date(selectedMessage.created_at).toLocaleString()}</p>
                                <p><strong>Message:</strong></p>
                                <p className="whitespace-pre-wrap border border-gray-200 p-3 rounded-md bg-gray-50">{selectedMessage.message}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
